"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.typedValues = void 0;
/** `Object.values` analogue which returns a well-typed array */
const typedValues = (object) => {
    return Object.values(object);
};
exports.typedValues = typedValues;
